import SportCodes from "../sports/common/sport-codes";
import FootballService from "./football-service";
import FlagFootballService from "./flag-football-service";
import TennisService from "./tennis-service";
import FootballStatsService from "./football-stats-service";
import TennisStatsService from "./tennis-stats-service";

class SportResolverService {
    constructor() {
        this.sportServices = {
            [SportCodes.Football]: FootballService,
            [SportCodes.FlagFootball]: FlagFootballService,
            [SportCodes.Tennis]: TennisService,
            [SportCodes.WomenTennis]: TennisService
        };
        this.sportStatServices = {
            [SportCodes.Football]: FootballStatsService,
            [SportCodes.FlagFootball]: FootballStatsService,
            [SportCodes.Tennis]: TennisStatsService,
            [SportCodes.WomenTennis]: TennisStatsService
        };
    }
    async resolveSportService(sportCode) {
        return this.sportServices[sportCode];
    }

    async resolveStatsService(sportCode) {
        return this.sportStatServices[sportCode];
    }
}

export default new SportResolverService();
